/** Learner. */
export class Learner {
  constructor(data) {
    this.id = data.id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.jobTitle = data.jobTitle;
    this.email = data.email;
    this.dateOfBirth = data.dateOfBirth;
    this.typeId = data.typeId;
    this.createdDate = data.createdDate;
    this.active = data.active;
    this.editDate = data.editDate;
    this.isVisible = data.isVisible;
    this.type = {
      id: data.type.id,
      name: data.type.name,
      code: data.type.code,
    };
    this.username = data.username;
    this.rbsServerId = data.rbsServerId;
    this.employeeId = data.employeeId;
  }
}

/** Learner with instructor notes. */
export class LearnerWithInstructorNotes extends Learner {
  constructor(data) {
    super(data);
    this.instructorNotes = data.instructorNotes;
  }
}
